import { FillsGraphDataState } from './data/FillsGraphDataState';
import { FillsGraphConfiguration } from './configuration/FillsGraphConfiguration';
import { StreamingWidgetState } from 'widgets/store/stream/WidgetStreamState';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState';
import { FillsGraphComponentState } from 'widgets/fillsGraph/store/component/FillsGraphComponentState';

export type FillsGraphWidgetState = StreamingWidgetState<FillsGraphDataState> &
    WidgetWithConfigState<FillsGraphConfiguration> &
    WidgetWithComponentState<FillsGraphComponentState>;

export interface FillsGraphWidgetsState {
    [widgetId: string]: FillsGraphWidgetState;
}

export const initialFillsGraphWidgetsState: FillsGraphWidgetsState = {};
